import { isGoalProgressUpdatable } from '@griply/utils';
import { useGoals } from 'features/goals';
import { useOpenGoalProgressAddEntry } from 'shared/contexts/goal-progress';
import { useEntityLinks } from 'shared/hooks/use-entity-links';
import { Goal } from 'shared/types/goal';

export const useGoalProgressUpdate = (goal: Goal | undefined) => {
  const goals = useGoals();
  const links = useEntityLinks();
  const openProgressAddEntryDialog = useOpenGoalProgressAddEntry();

  const onUpdate = () => {
    if (!goal?.metric) {
      return;
    }

    openProgressAddEntryDialog(goal.id, goal.metric);
  };

  return {
    canUpdate: !!goal && isGoalProgressUpdatable(goal, { goals, links }),
    onUpdate,
  };
};
